import Grid from '@mui/material/Grid';
import { FC, useState } from 'react';
import { useNavigate } from 'react-router';
import {Lead, LeadItem, LeadStatus, LeadsState, ModalType, TagsClosedEnum} from '../types/types';
import DeleteForm from './forms/deleteForm';
import HandledForm from './forms/handledForm';
import UnhandledForm from './forms/unhandledForm';

interface Props {
  selectedLead: LeadItem | Lead;
  handleCancel: () => void;
  leadsStatus?: LeadsState;
  singleLead?: boolean;
  refreshTableData?: () => Promise<void>;
}

const LeadsDialog: FC<Props> = ({ handleCancel, selectedLead, leadsStatus, refreshTableData, singleLead }) => {
  const [dialogStatus, setDialogStatus] = useState<ModalType>(leadsStatus === LeadsState.active || leadsStatus === LeadsState.handled  ? 'handled' : 'unhandled');
  const navigate = useNavigate();
  const isActive = selectedLead.tagsClosed?.type === TagsClosedEnum.Unsure || selectedLead.tagsClosed?.type === TagsClosedEnum.None;

  function unhandledFormCallback(value: LeadStatus): void {
    if (singleLead && value !== 'noContact') {
      const targetPath = isActive ? '/active' : dialogStatus;
      navigate(`/${dialogStatus !== 'delete' ? targetPath : '/handled'}`, {
        replace: true
      });
    }
  }

  function handledFormCallback(): void {
    if (singleLead) {
      const targetPath = isActive ? '/active' : `/${dialogStatus}`;
      navigate(targetPath, {
        replace: true
      });
    }
  }

  function deleteFormCallback(): void {
    if (singleLead) {
      const targetPath = isActive ? '/active' : dialogStatus;
      navigate(`/${dialogStatus !== 'delete' ? targetPath : 'handled'}`, {
        replace: true
      });
    }
  }

  return (
    <>
      <Grid container direction="column" justifyContent="center" alignItems="center">
        {dialogStatus === 'unhandled' && (
          <UnhandledForm
            leadId={selectedLead.id}
            setDialogStatus={setDialogStatus}
            leadsStatus={selectedLead?.leadStatus.type}
            leadName={selectedLead?.name ?? ''}
            callback={unhandledFormCallback}
            closeModal={handleCancel}
            refreshTableData={refreshTableData}
          />
        )}
        {dialogStatus === 'handled' && (
          <HandledForm
            leadId={selectedLead.id}
            leadName={selectedLead?.name ?? ''}
            tagsClosed={selectedLead?.tagsClosed.type}
            callback={handledFormCallback}
            closeModal={handleCancel}
            refreshTableData={refreshTableData}
          />
        )}
        {dialogStatus === 'delete' && (
          <DeleteForm leadId={selectedLead.id} callback={deleteFormCallback} closeModal={handleCancel} refreshTableData={refreshTableData} />
        )}
      </Grid>
    </>
  );
};

export default LeadsDialog;
